import { render } from "./InvestorContent.vue?vue&type=template&id=0d5977b4&scoped=true"
import script from "./InvestorContent.vue?vue&type=script&lang=js"
export * from "./InvestorContent.vue?vue&type=script&lang=js"

import "./InvestorContent.vue?vue&type=style&index=0&id=0d5977b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5977b4"]])

export default __exports__